import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackContextDeletedSpec,
  trackContextFailedSpec,
  trackContextFileDeletedSpec,
  trackContextFileUploadedSpec,
  trackContextFileUploadFailedSpec,
  trackContextFileUploadStartedSpec,
  trackContextLinkedSpec,
  trackContextPreviewedSpec,
  trackContextUnlinkedSpec,
  trackContextUpdatedSpec,
  trackContextUploadedSpec,
  trackLibraryCollectionCreatedSpec,
  trackLibraryDocumentAddedToCollectionSpec,
  trackLibraryDocumentScopeChangedSpec,
  trackLibraryDocumentUploadedSpec,
  trackLibraryLinkClickedSpec,
  trackLibraryUploadNudgeClickedSpec,
  type ContextDeleted,
  type ContextFailed,
  type ContextFileDeleted,
  type ContextFileUploaded,
  type ContextFileUploadFailed,
  type ContextFileUploadStarted,
  type ContextLinked,
  type ContextPreviewed,
  type ContextUnlinked,
  type ContextUpdated,
  type ContextUploaded,
  type LibraryCollectionCreated,
  type LibraryDocumentAddedToCollection,
  type LibraryDocumentScopeChanged,
  type LibraryDocumentUploaded,
  type LibraryLinkClicked,
  type LibraryUploadNudgeClicked,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const contextEvents: SnowplowEventMap = {
  [TrackingEventName.ContextFileUploadStarted]: (props) =>
    trackContextFileUploadStartedSpec(props as ContextFileUploadStarted),
  [TrackingEventName.ContextFileUploaded]: (props) =>
    trackContextFileUploadedSpec(props as ContextFileUploaded),
  [TrackingEventName.ContextFileUploadFailed]: (props) =>
    trackContextFileUploadFailedSpec(props as ContextFileUploadFailed),
  [TrackingEventName.ContextFileDeleted]: (props) =>
    trackContextFileDeletedSpec(props as ContextFileDeleted),
  [TrackingEventName.ContextPreviewed]: (props) =>
    trackContextPreviewedSpec(props as ContextPreviewed),
  [TrackingEventName.ContextLinked]: (props) =>
    trackContextLinkedSpec(props as ContextLinked),
  [TrackingEventName.ContextUnlinked]: (props) =>
    trackContextUnlinkedSpec(props as ContextUnlinked),
  [TrackingEventName.ContextUploaded]: (props) =>
    trackContextUploadedSpec(props as ContextUploaded),
  [TrackingEventName.ContextFailed]: (props) =>
    trackContextFailedSpec(props as ContextFailed),
  [TrackingEventName.ContextDeleted]: (props) =>
    trackContextDeletedSpec(props as ContextDeleted),
  [TrackingEventName.ContextUpdated]: (props) =>
    trackContextUpdatedSpec(props as ContextUpdated),
  [TrackingEventName.LibraryDocumentUploaded]: (props) =>
    trackLibraryDocumentUploadedSpec(props as LibraryDocumentUploaded),
  [TrackingEventName.LibraryCollectionCreated]: (props) =>
    trackLibraryCollectionCreatedSpec(props as LibraryCollectionCreated),
  [TrackingEventName.LibraryUploadNudgeClicked]: (props) =>
    trackLibraryUploadNudgeClickedSpec(props as LibraryUploadNudgeClicked),
  [TrackingEventName.LibraryLinkClicked]: (props) =>
    trackLibraryLinkClickedSpec(props as LibraryLinkClicked),
  [TrackingEventName.LibraryDocumentAddedToCollection]: (props) =>
    trackLibraryDocumentAddedToCollectionSpec(props as LibraryDocumentAddedToCollection),
  [TrackingEventName.LibraryDocumentScopeChanged]: (props) =>
    trackLibraryDocumentScopeChangedSpec(props as LibraryDocumentScopeChanged),
};
